import { Card } from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export interface BarChartDataSet {
  label: string;
  data: number[];
  borderColor: string;
  backgroundColor: string;
}

export type BarChartProps = {
  width?: string;
  chartTitle: string;
  labels: string[];
  datasets: BarChartDataSet[];
};

export function BarChart({
  chartTitle,
  labels,
  datasets,
  width = "100%",
}: BarChartProps) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: chartTitle,
      },
    },
  };

  const data = {
    labels,
    datasets,
  };
  return (
    <Card style={{ backgroundColor: "#f8f9fa", width: width}}>
      <Card.Body>
        <Bar options={options} data={data} />
      </Card.Body>
    </Card>
  );
}
